import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

const options = {
  ignoreHeaders: true,
};

const API_URL1 = 'https://c1-staff.raku-care.jp/internal/react';
const API_URL2 = 'https://c2-staff.raku-care.jp/internal/react';
// const API_URL1 = 'http://192.168.2.226/internal/react';
// const API_URL2 = 'http://192.168.2.228/internal/react';

const client = applyCaseMiddleware(
  axios.create({
    baseURL: API_URL1,
    withCredentials: true
  }),
  options
);

// client.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     switch (error.response?.status) {
//       case 422:
//         window.location.href = '/';
//         return error;
//     };
//   }
// );

client.interceptors.request.use(async (request) => {
  if (request.url?.includes("/staff_login")) {
    const conn = await axios.post(API_URL1 + "/get_conn_kb", {cp_cd: sessionStorage.getItem("cpCd")});
    if (Boolean(conn.data)) {
      localStorage.setItem("connKb", conn.data);
    };
  }
  const domain = await axios.post(API_URL1 + "/get_domain", {cp_cd: sessionStorage.getItem("cpCd")});
  if (Boolean(domain.data)) {
    //// request.baseURL = "https://" + domain.data + ".raku-care.jp/internal/react";
    //// request.baseURL = "https://rakucare-staff" + domain.data + ".raku-care.jp/internal/react";
    const CSTM_URL = "https://rakucare-" +  domain.data + ".raku-care.jp/internal/react";
    // const CSTM_URL = API_URL1;
    request.baseURL = CSTM_URL;
  } else {
    if (localStorage.getItem("connKb") === "c1") {
      request.baseURL = API_URL1;
    } else if (localStorage.getItem("connKb") === "c2") {
      request.baseURL = API_URL2;
    } else {
      request.baseURL = API_URL1;
    }
  };
  return request;
});

// ### ログイン画面 ##
// サインイン
export const login = (props) => {
  return client.post("/staff_login", props);
};

// ### 訪問予定画面 ###
// 訪問予定一覧取得
export const getDaySchedule = (props) => {
  return client.post("/day_schedule", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 指示内容取得
export const getInstructions = (props) => {
  return client.post("/instructions", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 実施内容登録
export const setInstructionsUpdate = (props) => {
  return client.post("/instructions_update", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 訪問予定キャンセル(解除)
export const setVisitCancellation = (props) => {
  return client.post("/visit_cancellation", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 訪問開始
export const setVisitStart = (props) => {
  return client.post("/visit_start", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 実績登録(修正)
export const setVisitUpdate = (props) => {
  return client.post("/visit_update", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 前回複写
export const setLastData = (props) => {
  return client.post("/last_data_copy", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// ### スケジュール・シフト画面 ###
// 月間スケジュール・シフト一覧取得
export const getCalendar = (props) => {
  return client.post("/calendar", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 日間スケジュール・シフト一覧取得
export const getDayShiftsSchedules = (props) => {
  return client.post("/day_shifts_schedules", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 休日申請内容一覧取得
export const getPTORequestList = (props) => {
  return client.post("/pto_request_list", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 休日申請内容登録
export const setPTORequestUpdate = (props) => {
  return client.post("/pto_request_update", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// ### 訪問予定変更画面 ###
// ログインスタッフ所属事業所一覧取得
export const getJgList = (props) => {
  return client.post("/get_bs_jg_list", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 事業所別利用者リスト取得
export const getRiyoList = (props) => {
  return client.post("/get_riyo_list", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 日・利用者毎訪問予定取得
export const getRiyoDaySearch = (props) => {
  return client.post("/get_riyo_day_search", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 割当可能職員リスト取得
export const getStaffKinmuList = (props) => {
  return client.post("/get_staff_kinmu_list", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 割当職員追加
export const addStaff = (props) => {
  return client.post("/add_staff", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 割当職員変更
export const changeStaff = (props) => {
  return client.post("/change_staff", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 割当職員削除
export const deleteStaff = (props) => {
  return client.post("/delete_staff", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 訪問予定削除
export const deleteService = (props) => {
  return client.post("/delete_staff_service", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

//サービス一覧取得
export const getServiceList = (props) => {
  return client.post("/add_service_select", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

//サービス条件取得
export const getServiceForm = (props) => {
  return client.post("/get_service_form", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// 基本サービス取得
export const getsvkCdList = (props) => {
  return client.post("/get_select_service_list", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};

// サービス登録
export const addService = (props) => {
  return client.post("/service_insert", props, {headers: {"X-CSRF-Token": sessionStorage.getItem("xCsrfToken")}});
};
